export default __webpack_public_path__ + "static/fast-shop-ee61bd9e0c8b810574c4600d8ded98cd.jpg";